module.exports = __webpack_public_path__ + "img/wholesale.8b49e2e.png";